import type { FunctionComponent, MouseEvent, PropsWithChildren } from 'react';
import { Button } from '@/core/tamagoshi/Button/Button';
import { Cross } from '@/core/tamagoshi/icons/Cross';
import { Text } from '@/core/tamagoshi/Text/Text';
import { translate } from '@/domains/core/localization/translate';
import styles from './FiltersPanelHeader.module.scss';
interface Props extends PropsWithChildren {
  className?: string;
  onClose?(event: MouseEvent): void;
}
const {
  title,
  closeButtonLabel
} = translate({
  "title": "Filter by",
  "closeButtonLabel": "Close"
});

/**
 * Head of filters panel
 *
 * ## Usage
 * ```
 * <FiltersPanelHeader count={0} />
 * ```
 */
export const FiltersPanelHeader: FunctionComponent<Props> = ({
  onClose,
  children
}) => <>
    <div className={styles.root}>
      <Text type="body1" className={styles.title}>
        {title}
      </Text>
      <Button className={styles.button} icon={<Cross />} variant="tertiary" onClick={onClose} data-testid="filtersPanelCloseButton" aria-label={closeButtonLabel} />
    </div>
    {children}
  </>;
FiltersPanelHeader.displayName = 'FiltersPanelHeader';